import React, { useEffect, useState } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import { post, put } from "../../../../utils/api";
import InputField from "../../../../Components/Masters/InputField";
import SelectField from "../../../../Components/Masters/SelectField";
import FileField from "../../../../Components/Masters/FileField";
import { validateNumber } from "../../../../utils/validateFields";
import { numberError } from "../../../../utils/validationMessage";
import Multiline from "../../../../Components/Masters/Multiline";
import MonthYearPicker from "../../../../Components/Common/MonthYearPicker";
import EditDialog from "../../../../Components/Common/EditDialog";
import AutoComplete from "../../../../Components/Common/AutoComplete";
import formatTitleWithOptional from "../../OptionalFeild";
import { useUser } from "../../../../context/AuthContext";

function AddRefrigeration({
  inputData,
  fetchData,
  id,
  data,
  setAddData,
  addData,
  setsnackOpen,
  addUrl,
  updateUrl,
}) {
  const { user } = useUser();

  const [errors, setErrors] = useState({});
  const initialState = {
    consumptionPeriod: {
      month: data?.consumptionPeriod?.month || "",
      year: data?.consumptionPeriod?.year || "",
    },
    emissionSource: data?.emissionSource || "",
    typeOfSubstance: data?.typeOfSubstance || "",
    quantityReleased: {
      value: data?.quantityReleased?.value || "",
      unit: data?.quantityReleased?.unit || "kg",
    },
    remarks: data?.remarks || "",
    documents: data?.documents || [],
    editRemarkReason: data?.editRemarkReason || "",
  };
  const [formData, setFormData] = useState(initialState);
  const [formData2, setFormData2] = useState(initialState);
  const [editDialog, setEditDialog] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  //  const [selectedMonth, setSelectedMonth] = useState(""); // Stores the selected month
  //  const [selectedYear, setSelectedYear] = useState(""); // Stores the selected year

  useEffect(() => {
    setFormData(initialState);
    setFormData2(initialState);
    setUploadedFiles(data?.documents || []);
  }, [data, id]);

  const handleChange = (e) => {
    const { name, value } = e.target;


    setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
    if (
      name.startsWith("quantityReleased.") ||
      name.startsWith("quantityConsumed.")
    ) {
      const [field, key] = name.split(".");
      console.log(field, key);

      setFormData((prevState) => ({
        ...prevState,
        [field]: {
          ...prevState[field],
          [key]: value,
        },
      }));

      setErrors((prevState) => ({
        ...prevState,
        [field]: {
          ...prevState[field],
          [key]: "",
        },
      }));
    } else {
      setFormData((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  const handleExitAgree = () => {
    setEditDialog(false);
    setAddData(false);
    setErrors({});
    // setSelectedMonth(data?.consumptionPeriod?.month || "");
    // setSelectedYear(data?.consumptionPeriod?.year || "");
    setFormData(initialState);
    setFormData2(initialState);
    setUploadedFiles(data?.documents || []);
  };

  const handleClose = () => {
    const isUnchanged = Object.keys(formData).every((key) => {
      if (key === "consumptionPeriod") {
        // Explicitly compare selectedMonth and selectedYear with initial values
      }
      if (typeof formData[key] === "object" && formData[key] !== null) {
        return JSON.stringify(formData[key]) === JSON.stringify(formData2[key]);
      }
      return formData[key] === formData2[key];
    });

    if (isUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    console.log("Form data for validation:", formData);

    inputData.forEach((input) => {
      const value = formData[input.fieldName] || "";
      // const value = formData[input.fieldName];
      const month = formData?.consumptionPeriod?.month;
      const year = formData?.consumptionPeriod?.year;
      if (input.fieldName === "consumptionPeriod") {
        if (month === "" || !validateNumber(month))
          newErrors["month"] = "Month is required";

        if (year === "" || !validateNumber(year))
          newErrors["year"] = "Year is required";

        return;
      }
      console.log(`Validating ${input.fieldName}:`, value);

      if (input.fieldName === "quantityReleased") {
        const quantityValue = parseFloat(value.value || 0); // Parse the value as a float
        if (!validateNumber(quantityValue) || quantityValue <= 0) {
          newErrors["quantityReleased.value"] = numberError;
          console.log(
            "Error: Quantity Released is invalid or less than or equal to 0."
          );
          return;
        }
      }

      // Additional checks for required fields, excluding quantityReleased.unit
      if (
        input.required &&
        input.type !== "number" &&
        (!value || value.trim() === "")
      ) {
        newErrors[input.fieldName] = `${input.title} is required.`;
        console.log(`Error: ${input.fieldName} is required.`);
      }
      if (user?.endUser && id && input.fieldName === "editRemarkReason") {
        if (
          !formData[input.fieldName] ||
          formData[input.fieldName].trim() === ""
        ) {
          newErrors[input.fieldName] = "Edit Remark Reason is required";
        }
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const Save = async () => {
    if (!validateForm()) return;

    // Prepare data to send, including only fields with values
    const dataToSend = {
      ...formData,
      documents: uploadedFiles,
      quantityReleased: {
        value: formData.quantityReleased.value,
        unit: "kg",
      },
    };
    if (user?.endUser && id) {
      dataToSend.requestStatus = "edit";
      dataToSend.requestMode = true;
      dataToSend.approvalStatus = "Pending";
    }

    try {
      const url = id
        ? `${updateUrl}?Id=${id}` // Append the Id parameter for PUT request
        : addUrl; // Use addUrl for POST request

      const response = await (id
        ? put(url, dataToSend) // Use updated URL with Id parameter
        : post(url, dataToSend)); // For POST, no Id needed

      // Handle success
      setsnackOpen({
        open: true,
        message: response.data.message,
        severity: "success",
      });
      fetchData();
      setFormData(initialState);
      setFormData2(initialState);
      handleExitAgree();
    } catch (err) {
      console.error("Error occurred:", err);
      if (err.response && err.response.data && err.response.data.errors) {
        const errorMessages = err.response.data.errors
          .map((error) => error.msg)
          .join(", ");
        setsnackOpen({
          open: true,
          message: errorMessages,
          severity: "error",
        });
      } else if (err.response && err.response.data) {
        setsnackOpen({
          open: true,
          message: err.response.data.message,
          severity: "error",
        });
      } else {
        setsnackOpen({
          open: true,
          message: "An unknown error occurred.",
          severity: "error",
        });
      }
    }
  };

  const renderInputField = (el) => {
    if (el.fieldName === "consumptionPeriod") {
      return (
        <Box sx={{ mt: 2 }}>
          <MonthYearPicker
            title={"Consumption Month"}
            {...{
              setFormData,
              setFormData2,
              formData,
              errors,
              setErrors,
            }}
          />
        </Box>
      );
    }
    if (el.fieldName === "typeOfSubstance") {
      return (
        <Box>
          <AutoComplete
            title={formatTitleWithOptional(el.title)}
            name={el.fieldName}
            value={formData[el.fieldName]}
            handleChange={handleChange}
            options={el.options}
            errors={errors[el.fieldName]}
            field={el.field}
          />
        </Box>
      );
    }

    if (el.options || el.type === "select") {
      return (
        <SelectField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          value={formData[el.fieldName]}
          handleChange={handleChange}
          options={el.options}
          errors={errors[el.fieldName]}
          url={el.url}
          field={el.field}
        />
      );
    }

    if (el.fieldName === "quantityReleased") {
      return (
        <Box>
          <InputField
            title="Quantity Released"
            handleChange={(e) => handleChange(e, "quantityReleased.value")}
            placeholder="Enter quantity"
            value={formData.quantityReleased?.value || ""}
            errors={errors["quantityReleased.value"]}
            fieldName="quantityReleased.value"
            adornmentText={"Kg"}
          />
        </Box>
      );
    }

    if (el.type === "file") {
      return (
        <FileField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          errors={errors[el.fieldName]}
          fileUrls={uploadedFiles}
          progress={uploadProgress[el.fieldName] || []}
          {...{ setUploadedFiles, setUploadProgress, setErrors }}
        />
      );
    }

    if (el.fieldName === "remarks")
      return (
        <Multiline
          title={formatTitleWithOptional(el.title)}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={formData[el.fieldName] || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
        />
      );

    if (el.fieldName === "editRemarkReason") {
      if (user?.endUser && id) {
        return (
          <Multiline
            title={formatTitleWithOptional(el.title)}
            handleChange={handleChange}
            placeholder={el.placeholder}
            value={formData[el.fieldName] || ""}
            errors={errors[el.fieldName]}
            fieldName={el.fieldName}
            required={true}
          />
        );
      }
      return null; // Don't render for other cases
    }

    return (
      <InputField
        title={formatTitleWithOptional(el.title)}
        handleChange={handleChange}
        placeholder={el.placeholder}
        value={formData[el.fieldName] || ""}
        errors={errors[el.fieldName]}
        fieldName={el.fieldName}
      />
    );
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.5rem",
        maxWidth: "100%",
        height: "100vh",
        justifyContent: "space-between",
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{ width: "88%", p: 3, backgroundColor: "#fff", overflow: "auto" }}
      >
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {id
            ? "Edit Refrigeration and Air Conditioning System"
            : "Add Refrigeration and Air Conditioning System"}
        </Typography>
        {inputData.map((el) => {
          if (
            (el.fieldName === "hours" ||
              el.fieldName === "industrialEquipment") &&
            formData.typeOfEntry !== "Individual"
          ) {
            return null; // Skip rendering these fields if typeOfEntry is not "Individual"
          }

          return <div key={el.fieldName}>{renderInputField(el)}</div>;
        })}

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "20%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleClose}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      {list()}
    </Drawer>
  );
}

export default AddRefrigeration;
